<template>
  <div class="fff">
    <div class="Browser_title">{{$t('settings.title')}}</div>
    <div class="Setting_ul" :style="{ height: isshow == 1 ? 'auto' : '75px' }">
      <img v-if="isshow != 1" src="@/assets/img/left2.png" />
      <img v-if="isshow == 1" src="@/assets/img/dow.png" />
      <div
        class="Browser_title Setting_l_title Noto SansBold"
        @click="isshow == 1 ? (isshow = 0) : (isshow = 1)"
      >
      {{$t('settings.tips4')}}
      </div>

      <div class="Setting_li">
        <div>{{$t('settings.tips5')}}</div>
        <input v-model="newpwd" :type="newpwdE ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwdE"
            @click="newpwdE = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwdE = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div class="Setting_li">
        <div>{{$t('settings.tips6')}}</div>
        <input v-model="newpwd2" :type="newpwd2E ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwd2E"
            @click="newpwd2E = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwd2E = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div class="Setting_li" @click.stop>
        <div>{{$t('settings.tips7')}}</div>
        <input v-model="oldpwd" :type="oldpwdE ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!oldpwdE"
            @click="oldpwdE = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="oldpwdE = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div @click.stop="Changepassword()" class="loginButton">
        {{$t('settings.tips4')}}
      </div>
    </div>
    <div class="Setting_ul" :style="{ height: isshow == 2 ? 'auto' : '75px' }">
      <img v-if="isshow != 2" src="@/assets/img/left2.png" />
      <img v-if="isshow == 2" src="@/assets/img/dow.png" />
      <div
        @click="isshow == 2 ? (isshow = 0) : (isshow = 2)"
        class="Browser_title Setting_l_title Noto SansBold"
      >
      {{$t('settings.tips8')}}
      </div>
      <div class="Setting_li">
        <div>{{$t('settings.tips9')}}</div>
        <input v-model="email" />
      </div>
      <div class="Setting_li">
        <div>{{$t('settings.tips10')}}</div>
        <input v-model="reEmail" />
      </div>
      <div class="Setting_li">
        <div>{{$t('settings.tips11')}}</div>
        <input v-model="pwd" :type="newpwd3E ? 'text' : 'password'" />
        <div class="login_input">
          <img
            v-if="!newpwd3E"
            @click="newpwd3E = true"
            src="@/assets/img/ege1.png"
            class="login_input_eye"
          />
          <img
            v-else
            @click="newpwd3E = false"
            src="@/assets/img/ege.png"
            class="login_input_eye"
          />
        </div>
      </div>
      <div @click="Changeemail()" class="loginButton">{{$t('settings.tips4')}}</div>
    </div>
    <div class="Setting_ul" :style="{ height: isshow == 4 ? 'auto' : '75px' }">
      <img v-if="isshow != 4" src="@/assets/img/left2.png" />
      <img v-if="isshow == 4" src="@/assets/img/dow.png" />
      <div
        @click="isshow == 4 ? (isshow = 4) : (isshow = 4)"
        class="Browser_title Setting_l_title Noto SansBold"
      >
      {{$t('settings.tips14')}}
      </div>
      <div class="Setting_li">
        <div>{{$t('settings.tips13')}}</div>
        <input :value="Intl.DateTimeFormat().resolvedOptions().timeZone" disabled />
      </div>
      <!-- <div class="Setting_li">
        <div>{{$t('settings.tips14')}}</div>
        <input :value="$t('English')" disabled />
      </div> -->
    </div>
    <!-- <div class="Setting_ul" :style="{ height: isshow == 3 ? 'auto' : '75px' }">
      <img
        v-if="isshow != 3"
        src="@/assets/img/left2.png"
      />
      <img
        v-if="isshow == 3"
        src="@/assets/img/dow.png"
      />
      <div  @click="isshow == 3 ? (isshow = 0) : (isshow = 3)" class="Browser_title Setting_l_title">Account preferences</div>
      <div class="Setting_li">
        <div>Enter Gps Interval</div>
        <input v-model="gps_interval" />
      </div>
      <div class="Setting_li">
        <div>Enter Gps Network</div>
        <input v-model="gps_network" />
      </div>
      <div @click="Changegps()" class="loginButton">Change  Preferences</div>
    </div>-->
  </div>
</template>

<script>
import { userChangepwd, userChangeemail, updateGpsConfig } from '@/api/user'

export default {
  name: 'HelloWorld',
  data () {
    return {
      isshow: 0,
      newpwd: '',
      newpwd2: '',
      oldpwd: '',
      msg: '',
      email: '',
      pwd: '',
      gps_network: '',
      gps_interval: '',
      reEmail: null,
      oldpwdE: false,
      newpwdE: false,
      newpwd2E: false,
      newpwd3E: false
    }
  },
  mounted () {},
  methods: {
    Changepassword () {
      let reg =
        /^\S*(?=\S{8,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*?。., ])\S*$/;
      if (!reg.test(this.newpwd)) {
        this.$message(
          this.$t('settings.msg1')
        )
        return false
      }
      if (this.newpwd === this.newpwd2) {
        var key = {
          newpwd: this.newpwd,
          oldpwd: this.oldpwd
        }
        userChangepwd(key).then((adj) => {
          // this.$message({
          //   message: adj.msg,
          //   type: 'success'
          // })
          if (adj.code !== 1) {
            this.$message({
              message: adj.msg,
              type: 'error'
            })
          } else {
            this.$message({
              message: adj.msg,
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: this.$t('settings.msg2'),
          type: 'error'
        })
        // this.$message.error("The two passwords don't match")
      }
    },
    Changeemail () {
      console.log(this.email)
      console.log(this.reEmail)
      if (this.email !== this.reEmail) {
        this.$message({
          message:this.$t('settings.msg3'),
          type: 'error'
        })
        return
      }
      var key = {
        email: this.email,
        pwd: this.pwd
      }
      userChangeemail(key).then((adj) => {
        if (adj.code === 1) {
          this.$message({
            message: adj.msg,
            type: 'success'
          })
          localStorage.setItem('email', this.email)
        } else {
          this.$message({
            message:this.$t('settings.msg3'),
            type: 'error'
          })
        }
      })
    },
    Changegps () {
      var key = {
        gps_interval: this.gps_interval,
        gps_network: this.gps_network
      }
      updateGpsConfig(key).then((adj) => {
        this.$message({
          message: adj.msg,
          type: 'success'
        })
        console.log(adj.data)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}

.Browser_title {
  line-height: 55px;
  padding-top: 10px;
  height: 55px;
  text-indent: 2.5%;
  font-weight: 700;
  font-size: 20px;
  color: #000927;
}
.Setting_ul {
  overflow: hidden;
  margin-left: 2.5%;
  width: 90%;
  max-width: 700px;
  position: relative;
  border-radius: 10px;
  border: 1px solid #e1e3e6;
  margin-bottom: 30px;
}
.Browser_title.Setting_l_title {
  font-size: 16px;
  margin-bottom: 10px;
}
.Setting_ul img {
  position: absolute;
  right: 27px;
  top: 27px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.Setting_li {
  margin-left: 2.5%;
  width: 330px;
  font-family: Noto Sans;
  font-size: 12px !important;
  color: #45484d;
  position: relative;
}
.login_input {
  position: absolute;
  height: 20px;
  width: 20px;
  right: -110px;
  top: 45px;
}
.login_input img {
  position: unset;
}
.Setting_li div {
  line-height: 20px;
  color: #707276;
}
.Setting_li input {
  border: 1px solid #e1e3e6;
  background: #f6f8fa;
  border-radius: 8px;
  height: 44px;
  line-height: 44px;
  margin: 10px 0 20px 0;
  width: 450px;
  text-indent: 10px;
}
.loginButton {
  width: 230px;
  height: 46px;
  line-height: 46px;
  float: left;
  margin-left: 2.5%;
  margin-bottom: 30px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue